
import Vue from "vue";
import dayjs from "dayjs";

export default Vue.extend({
  props: {
    InitialSize: {
      type: String,
      required: true,
    },
    NewSize: {
      type: String,
      required: true,
    },
    Date: {
      type: String,
      required: true,
    },
  },
  computed: {
    date() {
      return dayjs(this.Date).format("dddd, MMMM D, YYYY h:mm A");
    },
  },
});
